// extracted by mini-css-extract-plugin
module.exports = {"topics":"TopicList_topics_1966N","title":"TopicList_title_1fcEj","btn":"TopicList_btn_3LTcr"};